import {Trans} from '@ui/i18n/trans';
import {Product} from '../product';
import {CheckIcon} from '@ui/icons/material/Check';

interface FeatureListProps {
  product: Product;
  showMaxUsers?: boolean;
}

export function ProductFeatureList({
  product,
  showMaxUsers = false,
}: FeatureListProps) {
  const hasMaxUsers =
    showMaxUsers && typeof product.max_users === 'number' && product.max_users > 0;

  if (!product.feature_list.length && !hasMaxUsers) return null;

  return (
    <div className="mt-32 border-t pt-24">
      <div className="mb-10 text-sm font-semibold">
        <Trans message="What's included" />
      </div>
      {product.feature_list.map(feature => (
        <div key={feature} className="flex items-center gap-10 py-6 text-sm">
          <CheckIcon className="text-primary" size="sm" />
          <Trans message={feature} />
        </div>
      ))}
      {hasMaxUsers ? (
        <div className="flex items-center gap-10 py-6 text-sm">
          <CheckIcon className="text-primary" size="sm" />
          <Trans
            message="Up to :count users"
            values={{count: product.max_users}}
          />
        </div>
      ) : null}
    </div>
  );
}
